import {
  GET_NOTIFICATION,
  GET_NOTIFICATIONS_LIST,
  NotificationActionTypes,
  NotificationState,
  POST_NOTIFICATION,
  PUT_NOTIFICATION
} from '../types/notification.types';
import { Reducer } from 'redux';

const initialState: NotificationState = {
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1,
  selectedNotification: null,
  notifications: [],
  openNotifications: []
};

export const notificationReducer: Reducer<NotificationState> = (
  state: NotificationState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as NotificationActionTypes).type) {
    case GET_NOTIFICATION:
      return {
        ...state,
        postSuccess: null,
        selectedNotification: action.payload.selectedNotification,
        lastFetch: timeOfAction
      };
    case GET_NOTIFICATIONS_LIST:
      return {
        ...state,
        postSuccess: null,
        lastFetch: timeOfAction,
        notifications: action.payload.page.content,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case POST_NOTIFICATION:
    case PUT_NOTIFICATION:
      return {
        ...state,
        postSuccess: true,
        lastFetch: timeOfAction,
        selectedNotification: action.payload.selectedNotification
      };
    default:
      return state;
  }
};